<template>
  <div class="process-table">
    <Spin size="large" fix v-if="loading"></Spin>
    <Input
      v-show="filteredData.rows.length > 0"
      search
      enter-button
      v-model="foremanName"
      placeholder="可查询工长姓名"
      style="width: 200px; margin-bottom: 14px"
      @on-search="onFilter"
    />
    <div class="process-content">
      <div class="pt-row pt-header pt-fixed pt-top">
        <div
          v-for="(item, i) in filteredData.headers"
          class="pt-cell"
          :key="item.value"
          :class="i === 0 && ['pt-first pt-left']"
          @click="onClickHeader(i, item)"
        >
          {{ item.label }}
        </div>
      </div>
      <div
        class="pt-row"
        v-for="(item, i) in filteredData.rows"
        :key="i"
        @click="onClickRow(item)"
      >
        <div
          v-for="(_item, j) in item"
          :key="j"
          :class="[
            j === 0 && 'pt-fixed pt-left pt-first',
            _item.label !== '空闲' && j > 0 && 'pt-task',
          ]"
          class="pt-cell"
          :title="_item.label"
        >
          <template v-if="_item.label !== '空闲'"
            ><span @click="onViewWorkorderProcess(_item)">{{
              _item.label
            }}</span></template
          >
          <template v-else>
            {{ _item.label }}
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'workteamProcess',
  props: ['companyId', 'beginDate', 'endDate', 'date'],
  data() {
    return {
      // api列表
      api: {
        queryList: '/decorate/progress',
      },
      // 表格模型
      tableData: { headers: [], rows: [] },
      filteredData: { headers: [], rows: [] },
      loading: false,
      foremanName: '',
    }
  },
  watch: {
    companyId: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue) {
            this.getTableData()
          } else {
            this.tableData = { headers: [], rows: [] }
            this.filteredData = { headers: [], rows: [] }
          }
        }
      },
      immediate: true,
    },
    beginDate: {
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue && this.companyId) {
          this.getTableData()
        } else {
          this.tableData = { headers: [], rows: [] }
          this.filteredData = { headers: [], rows: [] }
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 预设，获取表格数据集
    getTableData() {
      this.loading = true
      let rows = []
      let headers = [{ label: '日期', value: -1 }]
      this.$axios
        .get(`${this.api.queryList}`, {
          params: {
            companyId: this.companyId,
            beginDate: this.beginDate,
            endDate: this.endDate,
            date: this.date,
          },
        })
        .then((resData) => {
          if (!resData.teams) return
          // 组织表头
          resData.teams.forEach((team) => {
            headers.push({
              label: team.leaderName,
              value: team.teamId,
            })
          })
          // 组织表格行数据
          const endDate = this.$dayjs(this.endDate)
          const interval = endDate.diff(this.beginDate, 'day')
          let i = 0
          while (i <= interval) {
            const rowDate = this.$dayjs(this.beginDate)
              .add(i, 'day')
              .format('YYYY-MM-DD')
            rows[i] = [{ label: rowDate }]
            resData.teams.forEach((team) => {
              if (!team.timelines) {
                rows[i].push('/')
              } else {
                const task = team.timelines.find(
                  (item) => item.date === rowDate
                )
                if (task) {
                  rows[i].push({
                    label: task.label,
                    bookingNo: task.bookingNo,
                  })
                } else {
                  rows[i].push({
                    label: '空闲',
                  })
                }
              }
            })
            i++
          }
          this.tableData.rows = rows
          this.tableData.headers = headers
          this.onFilter()
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClickRow(item) {
      // console.log(item[0])
      this.$emit('on-click-row', item[0])
    },
    onClickHeader(i, item) {
      if (i === 0) return
      // console.log(item)
      this.$emit('on-click-header', item)
    },
    onFilter(value) {
      if (!value) {
        this.filteredData.headers = this.tableData.headers
        this.filteredData.rows = this.tableData.rows
      } else {
        const headers = []
        const rows = []
        this.tableData.headers.forEach((item, index) => {
          if (index === 0) {
            headers.push({ ...item, rowCellIndex: index })
          } else {
            if (item.label.includes(value)) {
              headers.push({ ...item, rowCellIndex: index })
            }
          }
        })
        this.tableData.rows.forEach((item) => {
          const row = []
          headers.forEach((_item, index) => {
            row[index] = item[_item.rowCellIndex]
          })
          rows.push(row)
        })
        this.filteredData.headers = headers
        this.filteredData.rows = rows
      }
    },
    onViewWorkorderProcess({ bookingNo }) {
      this.$router.push(`/decorate/workorder/progress?bookingNo=${bookingNo}`)
    },
  },
}
</script>
<style lang="stylus" scoped>
.process-table
  width 100%
  height 100%
  overflow auto

  >>>.ivu-spin-fix
    z-index 20

  .process-content
    position relative
    display inline-block

  .pt-fixed
    position sticky !important

  .pt-top
    top 0
    z-index 10

  .pt-left
    left 0
    z-index 10

    &.pt-top
      z-index 11

  .pt-row
    height 20px
    white-space nowrap
    display block

    .pt-cell
      display inline-block
      width 65px
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      text-align left
      cursor pointer
      pointer-events auto

      &.pt-first
        width 90px
        font-weight bold
        background #fff

      &.pt-task
        background-color #ff9900
        color #fff

      &:hover
        background #19be6b
        color #fff

        &:before, &:after
          content ''
          position absolute
          z-index 0
          background rgba(#19be6b, 0.2)
          pointer-events none

        &:before
          width 65px
          height 100%
          top 0

        &:after
          width 100%
          height 21px
          left 0

    &.pt-header
      background #1529AD
      color #fff

      .pt-first
        background #1529AD
        color #fff

      &.pt-top
        z-index 11
</style>
